import { render, staticRenderFns } from "./ActBaseBtnHome.vue?vue&type=template&id=0bbb90fd&scoped=true&"
import script from "./ActBaseBtnHome.vue?vue&type=script&lang=js&"
export * from "./ActBaseBtnHome.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseBtnHome.vue?vue&type=style&index=0&id=0bbb90fd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb90fd",
  null
  
)

export default component.exports